//import React, { useState } from 'react';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './ImageCarousel.scss';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import serviceicon from "../../assets/logo/sec-title-icon.jpg";
import service1 from "../../assets/category/1.jpeg";
import service2 from "../../assets/category/2.jpeg";
//import service3 from "../../assets/category/kalash030.jpeg";
import service4 from "../../assets/category/3.jpeg";
import service5 from "../../assets/category/4.jpeg";
import service6 from "../../assets/category/5.jpeg";
import service7 from "../../assets/category/6.jpeg";
//import service8 from "../../assets/category/kalash080.jpeg";
const ImageCarousel = () => {

  const images = [
    service1,service2,service4,service5,service6,service7
  ];
  const text =[
    {
      
      content: 'The Grand Machal Adventure',
      button: 'Book Now',
    },
    {
      
      content: 'The Grand Machal Accomodation',
      button: 'Book Now',
    },
    {
      
      content: 'The Grand Machal Restaurent',
      button: 'Book Now',
    },
    {
      
      content: 'The Grand Machal Wedding Event',
      button: 'Book Now',
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrow:true,
    pauseOnHover: true,
    ///fade:true,
    
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  return (
<div>
        {/* <div className="service_title1">
            <div className="service_title">
                <img src={serviceicon} alt=''/>
                <h5>8 Award-Winning Multi Cuisine Restaurants</h5>
                <h1>Adventure Accommodation Restaurant Events & Wedding</h1>
            </div>
        </div>  */}
    <div style={{ maxWidth: '1200px', margin: '40px auto' }}>
      <Slider {...settings} className='image_sli'>
        {images.map((img, index) => (
          <div className='imagecaro' key={index} style={{ padding: '0 0px'}} >
            <img
              className='caro'
              src={img}
              alt={`Slide ${index + 1}`}
              style={{ width: '650px', height: '450px',  borderRadius: '12px',padding:'0 5px'}}
            />
            
          </div>
        ))} 
      </Slider>
    </div>
</div>
  );
};
export default ImageCarousel;